export const route = (relativePath: string): string => {
  let url = process.env.NEXT_PUBLIC_APP_URL as string;

  if (!url?.length) throw new Error('You must define NEXT_PUBLIC_APP_URL environment variable');

  if (!url.includes('http')) {
    const protocol = url.startsWith('localhost') ? 'http' : 'https';
    url = `${protocol}://${url}`;
  }

  if (relativePath.charAt(0) === '/') relativePath = relativePath.slice(1);

  return `${url}/${relativePath}`;
};

export const snakeToCamel = (snake_case: string): string =>
  snake_case.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
